import React from 'react'
import './services.css'
import {BiCheck} from 'react-icons/bi'

const Services = () => {
  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className='container services__container'>
        <article className='services'>
          <div className='service__head'>
            <h3>Technical Account Management</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Production Support & Incident Troubleshooting</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Customer Relationship Management</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Technical Problem Resolution</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Performance Optimization & KPI Improvement</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Cross-Functional Team Coordination</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Customer Success Strategy</p>
            </li>
          </ul>
         </article>
        <article className='services'>
          <div className='service__head'>
            <h3>Implementation Consulting</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Solution Architecture & Design</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Requirements Gathering & Analysis</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Complex System Implementation</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Migration & Modernization Planning</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Stakeholder Management & Communication</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Production Readiness & Launch Support</p>
            </li>
          </ul>
         </article>
        <article className='services'>
          <div className='service__head'>
            <h3>Customer Success Engineering</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Technical Onboarding & Adoption</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Customer-Centric Solution Design</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Performance Troubleshooting</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Knowledge Transfer & Documentation</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>User Adoption & Training</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Technical Escalation Management</p>
            </li>
          </ul>
         </article>
        <article className='services'>
          <div className='service__head'>
            <h3>Technical Project Management</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Requirements Assessment & Impact Analysis</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Agile/Scrum Leadership (PSM I & II)</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Modernization Initiative Planning</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Risk Mitigation & Problem Resolution</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Release Coordination & Validation</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Business-Technical Alignment</p>
            </li>
          </ul>
         </article>
      </div>
    </section>
  )
}

export default Services